// src/plugins/vuetify.js
// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import "vuetify/dist/vuetify.min.css";
import { useI18n } from "vue-i18n";
import { createVuetify } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import i18n from "../i18n";

// Paleta da marca Bindfy (redesign 2026)
const bindfyLight = {
  dark: false,
  colors: {
    background: "#f6f4fa",
    surface: "#ffffff",
    primary: "#7c16e0",
    "primary-darken-1": "#4a0a85",
    secondary: "#9b2bff",
    info: "#3d55c9",
    success: "#187a45",
    warning: "#a86a12",
    error: "#c92a4a",
    "on-primary": "#ffffff",
    "on-surface": "#221a4d",
    "on-background": "#221a4d",
  },
};

const bindfyDark = {
  dark: true,
  colors: {
    background: "#141021",
    surface: "#1d1830",
    primary: "#9b2bff",
    "primary-darken-1": "#7c16e0",
    secondary: "#c79bff",
    info: "#93a6f5",
    success: "#5fd695",
    warning: "#ecb45c",
    error: "#ff8ba3",
    "on-primary": "#ffffff",
    "on-surface": "#efecf9",
    "on-background": "#efecf9",
  },
};

// Tema inicial a partir do localStorage (mantem coerencia com o toggle)
const savedTheme =
  (typeof localStorage !== "undefined" && localStorage.getItem("bf-theme")) ||
  "bindfyLight";

const vuetify = createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  theme: {
    defaultTheme: savedTheme === "bindfyDark" ? "bindfyDark" : "bindfyLight",
    themes: {
      bindfyLight,
      bindfyDark,
    },
  },
  defaults: {
    VCard: { rounded: "lg" },
    VBtn: { rounded: "lg", style: "text-transform: none; letter-spacing: 0;" },
    VTextField: { variant: "outlined", density: "comfortable" },
    VSelect: { variant: "outlined", density: "comfortable" },
    VTextarea: { variant: "outlined" },
  },
});

export default vuetify;
